export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Ликвидный майнинг",
    "加入节点， 开始挖矿": "Присоединяйтесь к узлу, начните майнинг",
    "参 与": "Участвовать",
    "矿池数据": "Данные пула",
    "总产量": "Общий объем",
    "有效节点": "Активные узлы",
    "参与者": "Участники",
    "用户收入": "Доход пользователя",
    "挖矿榜单": "Рейтинг майнинга",
    "流动性挖矿收入": "Доход от ликвидного майнинга",
    "输出记录": "Журнал вывода",
    "地址": "Адрес",
    "数量": "Количество",
    "帮助中心": "Центр помощи",
    "希望它可以帮助你": "Надеемся, это вам поможет",
    "安全保障": "Гарантия безопасности",
    "我们有安全的审计报告": "У нас есть аудиторские отчеты",
    "伙伴": "Партнеры",
    "我们的商业伙伴": "Наши бизнес-партнеры",
    "首页": "Главная",
    "我的矿池": "Мой пул",
    "提取": "Вывод",
    "账户": "Аккаунт",
    "总挖矿金额": "Общая сумма майнинга",
    "可更换": "Заменяемый",
    "收益率": "Доходность",
    "币池名称": "Название пула",
    "最低金额": "Минимальная сумма",
    "收益率/24小时": "Доходность/24 часа",
    "挖矿记录": "История майнинга",
    "金额": "Сумма",
    "描述": "Описание",
    "时间": "Время",
    "已参与": "Участвует",
    "质 押": "Стейкинг",
    "已质押": "На стейкинге",
    "记录": "Запись",
    "兑换": "Обмен",
    "从": "От",
    "全部": "Все",
    "至": "До",
    "价格": "Цена",
    "确认": "Подтвердить",
    "矿池收益": "Доход пула",
    "今日收益": "Доход за сегодня",
    "普通矿池": "Обычный пул",
    "高级矿池": "Продвинутый пул",
    "全部的": "Все",
    "可用的": "Доступно",
    "申请加入": "Подать заявку на участие",
    "推荐朋友": "Рекомендовать друзьям",
    "一起赚取加密货币": "Зарабатывайте криптовалюту вместе",
    "查看详情": "Подробнее",
    "团队": "Команда",
    "推荐": "Реферал",
    "团队规模": "Размер команды",
    "直接发起人": "Прямые спонсоры",
    "总收入": "Общий доход",
    "今天的收入": "Доход за сегодня",
    "我的推荐链接": "Моя реферальная ссылка",
    "复制": "Копировать",
    "1. 获取链接": "1. Получите ссылку",
    "2. 邀请朋友": "2. Пригласите друзей",
    "3. 赚取加密货币": "3. Заработайте криптовалюту",
    "等级": "Уровень",
    "1 级": "Уровень 1",
    "2 级": "Уровень 2",
    "3 级": "Уровень 3",
    "用户地址": "Адрес пользователя",
    "币种": "Токен",
    "说明": "Детали",
    "状态": "Статус",
    "定时收益": "Периодический доход",
    "今日预收益": "Прогноз на сегодня",
    "累计收益": "Накопленный доход",
    "将矿池收益的BNB兑换成USDT后立即到账": "Обмен дохода с пула в BNB на USDT мгновенно",
    "将USDT提取后会在24小时内到达你的钱包": "Вывод USDT за 24 часа",
    "天": "Дни",
    "高级矿池收益": "Доход продвинутого пула",
    "质押收益": "Доход от стейкинга",
    "下次收益": "Следующий доход",
    "当前收益率": "Текущая доходность",
    "昨日收益": "Доход за вчера",
    "普通矿池收益率": "Доходность обычного пула",
    "高级矿池收益率": "Доходность продвинутого пула",
    "高级矿池限时开放": "Продвинутый пул открыт на время",
	"公告":"объявление",
	"我知道了":"Я понимаю"
};
